import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { TopconCwUiComponentsModule } from '../../topcon-cw-ui-components.module';
import { CrsSearchComponent } from './crs-search.component';

@NgModule({
    declarations: [CrsSearchComponent],
    imports: [CommonModule, TwcModule, TranslateModule, ReactiveFormsModule, TopconCwUiComponentsModule],
    exports: [CrsSearchComponent],
})
export class CrsSearchModule {}
